<template>
  <div
    class="filterPanel"
    :class="{ tile: simple }"
  >
    <div class="filterMultiple">
      <filter-result
        :data="getFilterGroups(['range', 'multiples', 'advanceds', 'others'])"
        :headTitle="headTitle"
        @close="close"
        v-if="!hideResult && !simple"
      >
        <div slot="title">
          <slot name="title"></slot>
        </div>
      </filter-result>
      <div class="row">
        <div
          class="col"
          v-if="getSearch"
        >
          <div
            class="input-title"
            v-if="getSearch.inputTitle"
          >
            {{ getSearch.inputTitle }}
          </div>
          <sky-main-input
            class="filterSearch"
            v-model="getSearch.value"
            @change="change(getSearch, $event)"
            v-bind="getSearch"
          >
          </sky-main-input>
        </div>
        <div
          class="col"
          v-if="getFilterGroups(['range']).length > 0"
        >
          <div
            class="input-title"
            v-if="getRange.inputTitle"
          >
            {{ getRange.inputTitle }}
          </div>
          <sky-range-input
            v-bind="getRange"
            v-model="getRange.value"
            @change="change(getRange, $event)"
          ></sky-range-input>
        </div>
        <div
          class="col"
          v-for="(item, index) in getFilterGroups(['others'])"
          :key="index"
        >
          <div
            class="input-title"
            v-if="item.inputTitle"
          >
            {{ item.inputTitle }}
          </div>
          <component
            :is="item.tagName"
            v-model="item.value"
            v-bind="item"
            @change="change(item, $event)"
          ></component>
        </div>
      </div>
      <div
        class="singleSelect"
        :class="{ active: hideBorder }"
        v-if="data.multiples && data.multiples.length != 0"
      >
        <div class="left">
          <sky-dropdown-select
            class="filterSelect"
            v-for="item in data.multiples"
            @change="change(item, $event)"
            :key="item.label"
            v-model="item.value"
            v-bind="item"
            :data="item"
          ></sky-dropdown-select>
        </div>
        <div class="right">
          <sky-condition
            v-for="(item, index) in data.condition"
            :key="index"
            @change="change(item, $event)"
            v-bind="item"
            v-model="item.value"
          ></sky-condition>
        </div>
      </div>
      <filter-modal
        @modal-change="modalChange"
        v-if="getAdvanceds.length != 0"
        @change="change($event)"
        class="filterModal"
        :groups="getFilterGroups(['advanceds', 'range', 'multiples', 'others'])"
      ></filter-modal>
    </div>
  </div>
</template>
<script>
/**
 * @Description: 过滤面板 需传递一个属性名为data 的JSON对象 数据改变自动向外触发search 方法
 * @author Junky
 * @date 2018/6/20
 */
import _ from 'lodash'

import layout from './layout/layout.vue'
import filterModal from './filterModal/index.vue'
import filterResult from './filterResult/index.vue'
import skyComponent from '@/components/iglobalwin/formComponents'
export default {
  components: {
    layout,
    filterModal,
    filterResult,
    ...skyComponent
  },
  props: {
    data: {
      default: () => {},
      type: Object
    },
    hideResult: Boolean,
    simple: Boolean,
    headTitle: {
      type: Boolean,
      default: true
    },
    hideBorder: Boolean
  },
  data() {
    return {
      oldVal: this.filterVal(this.data),
      test: [],
      test2: []
    }
  },
  computed: {
    createJson() {
      let obj = {
        onchange: function() {},
        categorys: {
          layout: [
            {
              left: this.getProp(this.data.multiples, 'props'),
              right: this.getProp(this.data.condition, 'props')
            }
          ]
        },
        advances: {
          layout: this.getProp(this.getAdvanceds, 'props')
        },
        result: {
          layout: this.getProp(this.getLabels, 'props')
        },
        groups: this.getGroups
      }
      return obj
    },
    getSearch() {
      return this.data.mainSearchInput
    },
    getGroups() {
      let groups = [
        this.getSearch,
        this.getRange,
        ...this.getMultiples,
        ...this.getCondition,
        ...this.getRange,
        ...this.getAdvanceds
      ]
      _.remove(groups, item => _.isEmpty(item))
      return groups
    },
    getMultiples() {
      return this.data.multiples || []
    },
    getCondition() {
      return this.data.condition || []
    },
    getAdvanceds() {
      return this.data.advanceds || []
    },
    getRange() {
      return this.data.range || {}
    }
  },
  watch: {
    data: {
      handler(val) {
        let v1 = this.filterVal(val)
        let v2 = this.oldVal
        if (!_.isEqual(v1, v2)) {
          this.oldVal = _.cloneDeep(v1)
          this.$emit('search', v1)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.appendProps('mainSearchInput', 'tagName', 'sky-main-input')
    this.appendProps('multiples', 'tagName', 'sky-dropdown-select')
    this.appendProps('range', 'tagName', 'sky-range-input')
    return this.appendProps('condition', 'tagName', 'sky-condition')
  },
  methods: {
    getFilterGroups(arr) {
      let list = []
      _.each(arr, item => {
        if (item === 'multiples') {
          this.appendProps('multiples', 'tagName', 'sky-dropdown-select')
        }

        let data = this.data[item]
        if (this.isObject(data)) {
          list.push(data)
        } else if (this.isArray(data)) {
          list = list.concat(data)
        }
      })
      return list
    },
    getProp(list, key) {
      return _.map(list, item => item[key])
    },
    appendProps(prop, key, value) {
      let data = this.data[prop]
      if (this.isObject(data)) {
        data[key] = value
      } else if (this.isArray(data)) {
        _.each(data, item => {
          this.isObject(item) && (item[key] = value)
        })
      }
      return data
    },
    isObject(val) {
      return Object.prototype.toString.call(val) === '[object Object]'
    },
    isArray(val) {
      return Object.prototype.toString.call(val) === '[object Array]'
    },
    json2Arr(val) {
      let list = []
      _.each(val, item => {
        if (_.isPlainObject(item)) {
          list.push(item)
        } else if (_.isArray(item)) {
          list = _.concat(list, ...item)
        }
      })
      return list
    },
    filterVal(val) {
      let res = {}
      let list = this.json2Arr(val)
      _.each(list, val => {
        if (_.isArray(val.prop)) {
          _.each(val.prop, (item, index) => {
            // res[item] = (val.value && val.value[index]) || undefined;
            res[item] = val.value && val.value[index]
          })
        } else {
          res[val.prop] = val.value
        }
      })
      return res
    },
    getSearchVal(vals) {
      let list = this.json2Arr(this.data)
      _.each(list, item => {
        _.each(vals, val => {
          if (item.label === val.label) {
            if (typeof item.value === 'object') {
              item.value = _.cloneDeep(val.value)
            } else {
              item.value = val.value
            }
          }
        })
      })
    },
    change() {
      this.$emit('change', ...arguments)
    },
    modalChange() {
      this.$emit('modalChange', ...arguments)
    },
    close(value) {
      this.$emit('close', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.filterPanel {
  margin-bottom: 10px;
  background-color: #fff;
  .filterSearch {
    width: 500px;
  }
  .filterMultiple {
    background-color: #fff;
    margin-top: 0;
    position: relative;
    padding: 20px 0 10px;
    .row {
      width: 100%;
      padding-left: 30px;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      // 后台管理-筛选换行
      flex-wrap: wrap;
      .col {
        margin-right: 30px;
        display: flex;
        align-items: center;
        // 后台管理-筛选换行
        margin-top: 10px;
        .toolFormItem {
          width: 200px;
        }
        .input-title {
          // min-width: 40px;
          // text-align: right;
          margin-right: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .singleSelect {
      padding: 0 30px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid rgba(216, 216, 216, 1);
      margin-top: 10px;
      .left {
        .filterSelect:not(:first-child) {
          margin: 8px 0 8px 30px;
        }
      }
      .right {
        display: flex;
      }
    }
    .singleSelect.active {
      border: none;
      height: auto;
      margin: 0;
    }
    .filterModal {
      position: absolute;
      right: 30px;
      top: 3px;
    }
  }
}
.filterPanel.tile {
  padding-left: 0;
  .filterMultiple {
    display: flex;
    align-items: center;
    .row {
      padding-left: 0;
    }
    .singleSelect {
      border-top: none;
      margin-top: 0;
      padding-left: 0;
    }
  }
}
</style>
